import { Action, createReducer, on } from '@ngrx/store';
import { SortState, SortDirectionType, SortDirectionEnum } from '../../../../models';
import { DataFilterAction } from '../../../actions';

const initialState: SortState = {
  sortDirection: SortDirectionEnum.ASC,
  sortOptionId: null,
  orderedDataIds: [],
  previousOrderedDataIds: null,
  shouldCalculateOnDataChange: true
};

const reducer = createReducer(
  initialState,
  on(DataFilterAction.definitionStateBuilt, (state, action) => {
    if (state.shouldCalculateOnDataChange) {
      return {
        ...state,
        sortOptionId: action.sortOptionId,
        orderedDataIds: action.orderedDataIds,
        previousOrderedDataIds: action.orderedDataIds,
        shouldCalculateOnDataChange: false,
        sortDirection: action.sortDirection || state.sortDirection
      };
    }

    return {
      ...state,
      sortOptionId: action.sortOptionId,
      previousOrderedDataIds: action.orderedDataIds,
    };
  }),
  on(DataFilterAction.sortingFinished, (state, action) => {
    return {
      ...state,
      sortOptionId: action.sortOptionId,
      orderedDataIds: action.sortedIds,
      previousOrderedDataIds: action.sortedIds,
      sortDirection: action.sortDirection || state.sortDirection,
    };
  }),
  on(DataFilterAction.forceCalculation, (state, _) => {
    return {
      ...state,
      orderedDataIds: state.previousOrderedDataIds,
    };
  }),
  on(DataFilterAction.toggleSortDirection, (state) => {
    return {
      ...state,
      sortDirection: (state.sortDirection === SortDirectionEnum.ASC ? SortDirectionEnum.DSC : SortDirectionEnum.ASC) as SortDirectionType,
    };
  }),
);

export function sortReducer(state = initialState, action: Action): SortState {
  return reducer(state, action);
}
